import axios from "axios";
import React from "react";

export default function AddProduct() {
  const product = {
    brandName: "Cadet Drill",
    productName: "NCC Leather Oxford Shoe",
    category: "Defence Essentials",
    groupId: "NC001U23",
    skuId: "NC001U23BL",
    hsnCode: 6402,
    mrp: 999,
    discount: 350,
    price: 650,
    taxPercentage: 12,
    // availableColors: ["White", "Black", "Grey", "Blue"],
    color: "Black",
    availableSize: [
      {
        size: "5",
        inventory: 2,
      },
      {
        size: "6",
        inventory: 2,
      },
      {
        size: "7",
        inventory: 15,
      },
      {
        size: "8",
        inventory: 12,
      },
      {
        size: "9",
        inventory: 2,
      },
      {
        size: "10",
        inventory: 2,
      },
      // {
      //   size: "XXXL",
      //   inventory: 0,
      // },
    ],
    sizeChart: "",
    length: 32.5,
    breadth: 20.5,
    height: 11,
    countryOfOrigin: "India",
    weight: 1.08,
    description:
      "Enhance your cadet training with our top-quality soft leather drill shoes with Airmix Sole for JW/JD Cadets! Our shoes are designed with precision and durability in mind, making them the perfect choice for any cadet or drill team member. They offer a combination of reliability, affordability, and style, ensuring that you can perform your best while looking great.",
    images: [
      "https://ambhos-products-images.s3.ap-south-1.amazonaws.com/NCC+Leather+Oxford+Shoe+with+Airmix+Sole+1.svg",
      "https://ambhos-products-images.s3.ap-south-1.amazonaws.com/NCC+Leather+Oxford+Shoe+with+Airmix+Sole+2.svg",
      "https://ambhos-products-images.s3.ap-south-1.amazonaws.com/NCC+Leather+Oxford+Shoe+with+Airmix+Sole+3.svg",
    ],
  };

  // ****** Uncomment if want to add product*********
  const handleAddProduct = () => {
    //   console.log("Adding Triggered");
    //   axios
    //     .post(`${process.env.REACT_APP_BACKEND_LINK}/addproduct`, product)
    //     .then((res) => console.log(res))
    //     .catch((err) => console.log(err));
  };

  return (
    <div>
      <h1>Add Product</h1>
      <button onClick={handleAddProduct}>Add</button>
    </div>
  );
}
